import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { useSEO } from "../lib/useSEO";
import { Container, SectionHeading, CTAButton, Reveal } from "../components/site/ui";

export default function PilotProgram() {
  const { t, lang } = useLang();
  const p = t.pilot;
  useSEO({ title: p.metaTitle, description: p.metaDesc, path: "/pilot-program", lang });

  return (
    <div>
      <section className="pt-28 pb-16 border-b border-cool-dark" data-testid="pilot-hero">
        <Container><SectionHeading eyebrow={p.eyebrow} title={p.title} intro={p.intro} /></Container>
      </section>

      <section className="py-16 border-b border-cool-dark" data-testid="pilot-steps">
        <Container>
          <div className="relative border-l border-cool-dark ml-3">
            {p.steps.map((s, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="relative pl-10 pb-12 last:pb-0" data-testid={`pilot-step-${i}`}>
                  <span className="absolute -left-[9px] top-1 w-4 h-4 bg-nb-base border border-cyan flex items-center justify-center">
                    <span className="w-1.5 h-1.5 bg-cyan" />
                  </span>
                  <div className="font-mono text-xs text-cyan">{`FASE 0${i + 1}`}</div>
                  <h3 className="mt-1 font-display text-xl text-white">{s.t}</h3>
                  <p className="mt-2 text-cool-light leading-relaxed max-w-2xl">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>

      <section className="py-24" data-testid="pilot-cta">
        <Container>
          <div className="border border-cool-dark bg-nb-deep p-10 max-w-3xl">
            <h3 className="font-display text-2xl text-white">{t.common.selectingPartners}</h3>
            <p className="mt-3 text-cool-light">{p.intro}</p>
            <div className="mt-7"><CTAButton to="/contact" variant="gold" testId="pilot-cta-btn">{t.common.applyPilot}</CTAButton></div>
          </div>
        </Container>
      </section>
    </div>
  );
}
